import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { CargoInputModel } from '../models/CargoInputModel';

interface cargoInputState {
    cargoInput: CargoInputModel,
    selectedCargoId: string,
    cargoInputExpand: boolean,
    triggerFocusChartererInput: number,
    triggerSave: number,
    triggerRefreshInput: number
}

const initialState: cargoInputState = {
    cargoInput: {
        id: "",
        charterer: "",
        orderDetail: "",
        cargoType: 0,
        dwtMin: null,
        dwtMax: null,
        loadPort: 0,
        disport: 0,
        lay: "",
        can: "",
        remarks: "",
        fixed: false
    } as CargoInputModel,
    selectedCargoId: "",
    cargoInputExpand: true,
    triggerFocusChartererInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0
}

export const CargoInputSlice = createSlice({
    name: "CargoInput",
    initialState,
    reducers: {
        setCargoInputId: (state, action: PayloadAction<string>) => {
            state.cargoInput.id = action.payload;
        },
        setCargoInput: (state, action: PayloadAction<CargoInputModel>) => {
            state.cargoInput = action.payload;
        },
        setCharterer: (state, action: PayloadAction<string>) => {
            state.cargoInput.charterer = action.payload;
        },
        setOrderDetail: (state, action: PayloadAction<string>) => {
            state.cargoInput.orderDetail = action.payload;
        },
        setCargoType: (state, action: PayloadAction<number>) => {
            state.cargoInput.cargoType = action.payload;
        },
        setDwtMin: (state, action: PayloadAction<number | null>) => {
            state.cargoInput.dwtMin = action.payload;
        },
        setDwtMax: (state, action: PayloadAction<number | null>) => {
            state.cargoInput.dwtMax = action.payload;
        },
        setLoadPort: (state, action: PayloadAction<number>) => {
            state.cargoInput.loadPort = action.payload;
        },
        setDisport: (state, action: PayloadAction<number>) => {
            state.cargoInput.disport = action.payload;
        },
        setLay: (state, action: PayloadAction<string>) => {
            state.cargoInput.lay = action.payload;
        },
        setCan: (state, action: PayloadAction<string>) => {
            state.cargoInput.can = action.payload;
        },
        setRemarks: (state, action: PayloadAction<string>) => {
            state.cargoInput.remarks = action.payload;
        },
        setSelectedCargoId: (state, action: PayloadAction<string>) => {
            state.selectedCargoId = action.payload;
        },
        setCargoInputExpand: (state, action: PayloadAction<boolean>) => {
            state.cargoInputExpand = action.payload;
        },
        setTriggerFocusChartererInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusChartererInput = action.payload;
        },
        resetCargoInput: (state) => {
            state.cargoInput = initialState.cargoInput;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
        setFixed: (state, action: PayloadAction<boolean>) => {
            state.cargoInput.fixed = action.payload;
        },
    }
});

export const cargoInputSelector = createSelector(
    (state: RootState) => state.cargoInput,
    (data) => data
);

export const {
    setCargoInputId,
    setCargoInput,
    setCharterer,
    setOrderDetail,
    setCargoType,
    setDwtMin,
    setDwtMax,
    setLoadPort,
    setDisport,
    setLay,
    setCan,
    setRemarks,
    setSelectedCargoId,
    setCargoInputExpand,
    setTriggerFocusChartererInput,
    resetCargoInput,
    setTriggerSave,
    setTriggerRefreshInput,
    setFixed
} = CargoInputSlice.actions;

export default CargoInputSlice.reducer;